var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBase',{class:_vm.classes,attrs:{"view-box":"0 0 640 512"}},[_c('path',{attrs:{"d":"M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }